import { createAsyncAction } from 'async-selector-kit'
import shortid from 'shortid'
import moment from 'moment'
import { onIsLoading } from '../../../../utils/onLoading'
import { UnitCancel } from '../../../Units/reducer'
import { CANCEL_LIST } from '../../../../firebase/config'
import { onError } from '../../../../utils/onError'
import { onSuccess } from '../../../../utils/onSuccess'
import { clientLogger } from '../../../../utils/observability'

const updateCancelList = async (model: UnitCancel) =>
  window.firebase
    .database()
    .ref()
    .child(`${CANCEL_LIST}/${model.id}`)
    .update(model)

const getCancelEffectiveDate = (moveOut?: string) => {
  if (!moveOut) return undefined

  const parsed = moment.utc(moveOut, 'MM-DD-YYYY', true)
  return parsed.isValid() ? parsed.endOf('day').toISOString() : undefined
}

export function prepareCancelSubscriptionListModel(model: UnitCancel): UnitCancel {
  if (!model.id) {
    model.id = model.subscriptionId || shortid.generate()
    model.isCanceled = false
    model.paymentStatus ??= 'pending'
    model.subscriptionCancelled ??= false
    model.requestEmailSent ??= false
    model.cancelRequestDate ??= new Date().toISOString()
    model.cancelEffectiveDate ??= getCancelEffectiveDate(model.moveOut)
  } else {
    model.isCanceled = true
  }

  return model
}

/**
 * Core cancel subscription list logic. Exported for testing (success, error).
 */
export async function executeCancelSubscriptionList(model: UnitCancel): Promise<void> {
  onIsLoading(true)
  try {
    prepareCancelSubscriptionListModel(model)
    clientLogger.action('subscription_cancel_requested', {
      subscriptionId: model.subscriptionId,
      customerProfileId: model.customerProfileId,
      unitId: model.unitId,
      masterId: model.masterId,
      moveOut: model.moveOut,
    })
    await updateCancelList(model)
    clientLogger.info('subscription_cancel_saved', {
      subscriptionId: model.subscriptionId,
      cancelEffectiveDate: model.cancelEffectiveDate,
      requestEmailSent: model.requestEmailSent,
    })
    onSuccess('Successfully cancelled subscription.')
  } catch (error) {
    clientLogger.error('subscription_cancel_failed', {
      subscriptionId: model.subscriptionId,
      error,
    })
    onError('Failed to update firebase')
  } finally {
    onIsLoading(false)
  }
}

export const [cancelSubscriptionList, _, cancelSubscriptionListError] =
  createAsyncAction(
    {
      id: 'cancel-subscription-list',
      async: () => async (model: UnitCancel) => {
        await executeCancelSubscriptionList(model)
      },
    },
    []
  )
